import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, HelpBlock, FormControl } from 'react-bootstrap';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import momentLocaliser from 'react-widgets-moment';
import utils from '../../services/utils';
import 'react-widgets/dist/css/react-widgets.css';

momentLocaliser(moment);  //??

const DateTimeInput = ({ showTime, horizontal, required, labelCol = 3, valueCol = 9, input: { onChange, value, name }, label, type, help, meta: { touched, error, warning }, dateFormat, ...props }) => {
	const validationState = touched && (error && "error") || (warning && "warning") || null;

	let dateValue = null;
	if (value) {
		dateValue = utils.parseDateTime(value, dateFormat);
	}

	const formControl = <DateTimePicker name={name} onChange={onChange} value={dateValue} time={showTime} {...props} />;
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState}>
				<Col componentClass={ControlLabel} sm={labelCol}>
					{label}{labelHint}
				</Col>
				<Col sm={valueCol}>
					{formControl}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState}>
			<ControlLabel>{label}{labelHint}</ControlLabel>
			{formControl}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

DateTimeInput.propTypes = {
	showTime: PropTypes.bool,
	horizontal: PropTypes.bool,
	input: PropTypes.object,
	label: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	placeholder: PropTypes.string,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	value: PropTypes.string
};

export default DateTimeInput;